export default function auth ({ next, store }){
  if(!store.getters['auth/authenticated'] || ![3, 4].includes(store.getters['auth/authenticated'].role)){
      return next({
         name: 'Home'
      })
  }
  return next()
 }
